
import { useEffect } from 'react';
import { useLocation } from 'wouter';

export function useScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    // Wait for both the current frame to complete AND ensure DOM is ready
    // This fixes Safari's first-time navigation blank screen issue
    requestAnimationFrame(() => {
      // Double RAF ensures we're past the layout phase
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
    });
  }, [location]);
}
